export interface Place {
  id: string; // Guid en C# se mapea a string en TypeScript
  name: string;
  description: string;
  lat: number;
  longi: number;
  price?: Price; // Price es opcional en C#, por lo que se marca como opcional en TypeScript
  placeType?: PlaceType; // PlaceType es opcional en C#, por lo que se marca como opcional en TypeScript
  webSite: string;
  direccion: string;
  calificacion?: number; // Calificacion es opcional en C#, por lo que se marca como opcional en TypeScript
  urlGoogle: string;
  horarios: string[]; // Arreglo de strings
  fotos: string[]; // Arreglo de strings
  aprobado: boolean; // Aprobado es un booleano
}

export enum PlaceType {
  Plaza = 0,
  ParqueTematico = 1,
  Campo = 2,
  JuegosNiños = 3,
  CamasElasticas = 4,
  ParqueAcuatico = 5,
  Museo = 6,
  Granja = 7,
  ParqueNatural = 8,
  EscapeRooms = 9,
  Restaurante = 10,
  Zoologicos = 11,
  Cine = 12,
  Arcade = 13,
  Shopping = 14,
}
export enum Price {
  Gratis = 0,
  Economico = 1,
  Moderado = 2,
  Costoso = 3,
}
export interface Category {
  label: string;
  icon: string;
}